"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Throwable = void 0;
const Effect_1 = require("./Effect");
const emit_1 = require("../tools/emit");
const tail_1 = require("../tools/tail");
const forward_1 = require("../tools/forward");
const isResolved = (e) => e[0];
class Throwable extends Effect_1.Effect {
    constructor(a) {
        super();
        this.fmap = (f) => Throwable.fmap(f, this);
        this.bind = (f) => Throwable.bind(f, this);
        this.identity = () => Throwable;
        this.isValide = () => Throwable.isResolved(this);
        this._open = () => this.record;
        this.isResolved = () => Throwable.isResolved(this);
        this.isThrown = () => !Throwable.isResolved(this);
        this.fromResolved = () => Throwable.fromResolved(this);
        this.fromThrown = () => Throwable.fromThrown(this);
        this.fromThrowable = (d) => Throwable.fromThrowable(d, this);
        this.ThrowableToList = () => Throwable.ThrowableToList(this);
        this.case = (f, n) => Throwable.case(this, f, n);
        this.record = a;
    }
}
exports.Throwable = Throwable;
_a = Throwable;
Throwable.fmap = (f, a) => isResolved(a.record) ? Throwable.resolved(f(a.fromResolved())) : new Throwable(a.record);
Throwable.bind = (f, a) => isResolved(a.record) ? f(a.fromResolved()) : new Throwable(a.record);
Throwable.from = (a) => a instanceof Error ? Throwable.thrown(a) : Throwable.resolved(a);
Throwable.lift = (f) => (a) => Throwable.fmap(f, a);
Throwable.resolved = (a) => new Throwable([true, a]);
Throwable.thrown = (a) => !(a instanceof Error) ? new Throwable([false, new Error(a)]) : new Throwable([false, a]);
Throwable.isResolved = (a) => isResolved(a.record);
Throwable.isThrown = (a) => !Throwable.isResolved(a);
Throwable.fromResolved = (a) => isResolved(a.record) ? a.record[1] : (0, emit_1.emit)(a.record[1]);
Throwable.fromThrown = (a) => !isResolved(a.record) ? a.record[1] : (0, emit_1.emit)('Throwable resolved');
Throwable.fromThrowable = (d, a) => isResolved(a.record) ? a.fromResolved() : d;
Throwable.listToThrowable = (a) => a.length === 0 ? Throwable.thrown(new Error('empty')) : Throwable.resolved(a[0]);
Throwable.ThrowableToList = (a) => isResolved(a.record) ? [a.fromResolved()] : [];
Throwable.catThrowables = (a) => [
    ...(a.length && isResolved(a[0].record) ? [a[0].fromResolved()] : []),
    ...(a.length ? Throwable.catThrowables((0, tail_1.tail)(a)) : [])
];
Throwable.mapThrowable = (f, a) => [
    ...(a.length ? (0, forward_1.forward)(f(a[0]), (b) => isResolved(b.record) ? [Throwable.fromResolved(b)] : []) : []),
    ...(a.length ? Throwable.mapThrowable(f, (0, tail_1.tail)(a)) : [])
];
Throwable.liftFromThrowable = (f) => (...a) => {
    try {
        return Throwable.resolved(f(...a));
    }
    catch (e) {
        return Throwable.thrown(e);
    }
};
Throwable.liftFromThrowableAsync = (f) => (...a) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return Throwable.resolved(yield f(...a));
    }
    catch (e) {
        return Throwable.thrown(e);
    }
});
Throwable.case = (a, f, n) => isResolved(a.record) ? f(a.fromResolved()) : n(a.fromThrown());
//# sourceMappingURL=Throwable.js.map